<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar></navbar>
			<!--导航-->
			<!--banner-->
			<div class="banner_box">
				<img class="bg" src="../../assets/free-sample-kit/bg_h5.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				/>
				<div class="msg_box">
					<div class="title"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Fast, Reliable Answers at the Point of Care
					</div>
					<div class="tit"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Empower your healthcare facility with rapid POC COVID and Flu Tests.
					</div>
					<div class="txt"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx delivers rapid POC diagnostic tests for COVID-19 and Flu A/B, allowing healthcare providers to diagnose accurately and treat quickly. Rely on CorDx to get the POC tests your facility needs when cases start to spike.
					</div>
					<div
						class="txt2"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="700"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Experience Better Point-of-Care Testing for Yourself
					</div>
					<div
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="700"
						data-aos-offset="0"
						data-aos-once="true"
						class="btn_box btn_el"
						style=""
						@click="goForm"
					>
						Request a Free Sample Kit<img src="../../assets/img/icon_w.webp" />
					</div>
				</div>
			</div>
			<!--banner-->
			<!--块1-->
			<div class="block_1">
				<div class="block_1_top">
					<div class="img_box"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/free-sample-kit/block_1.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							CorDx Tyfast<br />
							Flu A/B & COVID-19<br />
							Multiplex Rapid Test
						</div>
						<div class="tit">
							Authorized for Emergency Use (EUA)
						</div>
						<div class="text">
							The CorDx Tyfast Flu A/B & COVID-19 Multiplex Rapid Test is a lateral flow immunoassay intended for the qualitative detection and differentiation of SARS-CoV-2 and influenza A and B antigens. The test provides an efficient and accurate diagnostic solution in 10 minutes, giving healthcare providers and communities a rapid and reliable way to prioritize their health. 
						</div>
					</div>
				</div>
				<div class="info_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">
						Always Have Answers in Stock
					</div>
					<div class="text">
						CorDx manufactures rapid COVID and Flu POC tests made to empower patients and providers with the answers they need. When peak cold & flu season strikes, we have the capacity to make sure you meet the spike in demand. 
					</div>
				</div>
				<div class="block_1_el">
					<div class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/free-sample-kit/block_2.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							You Provide the Care.<br />
							We’ll Handle the Tests.
						</div>
						<div class="text">
							Soft swabs. Easy instructions. Fast results. CorDx diagnostic products are designed so you can deliver a great patient experience, from test to treatment. CorDx POC diagnostic tests are FDA-authorized, reimbursable and easy to administer – so all you have to worry about is providing care.
						</div>
					</div>
				</div>
				<div class="block_1_el">
					<div class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/free-sample-kit/block_3.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							There’s Nothing<br />
							Between You and the<br />
							Tests Your Patients Need
						</div>
						<div class="text">
							CorDx has already figured out capacity, quality control, packing, and other logistical hurdles. Since we own our supply chain, there are no gaps that could keep us from getting our products exactly where you need them. Honest timelines and clear terms allow you to work confidently, knowing your patients will always have reliable access to the tests they need. 
						</div>
					</div>
				</div>
				<div class="block_1_el">
					<div class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/free-sample-kit/block_4.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							We Work With You
						</div>
						<div class="text">
							Customizable quantities and specifications allow you to adapt your business's strategy to a rapidly changing industry and your customer's business. Capitalize on volume discounts that meet the pricing needs of your customers and sales channel requirements.
						</div>
					</div>
				</div>
				<div class="btn_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="btn_box btn_el" style="" @click="goForm">
						REQUEST YOUR FREE TEST<img src="../../assets/img/icon_w.webp" style="top: 12px;" />
					</div>
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="block_2_main">
					<img class="logo" src="../../assets/img/logo_color.png"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					/>
					<div class="title"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="300"
						data-aos-offset="0"
						data-aos-once="true"
					>
						When Answers Can’t Wait
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="500"
						data-aos-offset="0"
						data-aos-once="true"
					>
						CorDx manufactures point-of-care and over-the-counter rapid diagnostic products across a variety of categories, including infectious disease, reproductive & sexual health, substance abuse, and other health and marker tests. With authorization for use in the US (FDA), Europe (CE Mark) and China (NMPA), CorDx tests are known for their comfort, speed and accuracy. 
					</div>
					<div class="text"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="700"
						data-aos-offset="0"
						data-aos-once="true"
					>
						Since 2006, CorDx has developed diagnostic products while establishing a solid supply chain foundation, allowing it to provide better quality, more affordable tests for distributors, healthcare providers and patients alike.
					</div>
					<div class="bg"
						data-aos="fade-in"
						data-aos-duration="400"
						data-aos-delay="1000"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/free-sample-kit/block_6.webp" />
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块3-->
			<div class="block_3">
				<div class="block_3_el">
					<div class="img_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<img src="../../assets/free-sample-kit/block_5.webp" />
					</div>
					<div class="msg_box"
						data-aos="fade-up"
						data-aos-duration="400"
						data-aos-delay="100"
						data-aos-offset="0"
						data-aos-once="true"
					>
						<div class="title">
							Rapid POC Tests for Covid and Flu
						</div>
						<div class="text">
							Ensure your customers have the diagnostics they need when they need them.
						</div>
						<div class="btn_main">
							<div class="btn_box btn_el" style="" @click="goForm">
								REQUEST A FREE SAMPLE KIT<img src="../../assets/img/icon_w.webp" style="top: 12px;" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块3-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import contact from '@/component/contact.vue'  //联系我们
export default {
	components:{
		navbar,
		footerBox,
		fixed,
		contact,
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
		document.title = 'Free Sample Kit - CorDx';
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goForm() {
			let that = this;
			window.location.href = 'https://9503031.extforms.netsuite.com/app/site/crm/externalleadpage.nl?compid=9503031&formid=1&h=AAFdikaIQ2PXFz401i3VE_HOLtHYK7BnQWKsJ4kggWf6fmweWho';
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	//块1
	.block_3{
		width: 100%;
		margin: 0 auto;
		position: relative;
		padding: 40px 20px 70px 20px;
		.block_3_el{
			width: 100%;
			.btn_main{
				text-align: center;
				.btn_el{
					height: 50px;
					line-height: 50px;
					padding-top: 2px;
					margin-top: 40px;
					background-color: #F26F32;
					color: #ffffff;
					border: none;
					font-size: 20px;
					border-radius: 46px;
				}
			}
			.msg_box{
				.text{
					padding-top: 12px;
					font-size: 18px;
				}
				.title{
					padding-top: 20px;
					font-size: 30px;
				}
			}
			.img_box{
				width: 100%;
				img{
					width: 100%;
				}
			}
		}
	}
	//块2
	.block_2{
		padding: 40px 20px;
		background-color: #415A75;
		.block_2_main{
			width: 100%;
			padding: 35px 18px 45px 18px;
			background-color: #ffffff;
			border-radius: 15px;
			text-align: center;
			.bg{
				padding-top: 40px;
				img{
					width: 100%;
				}
			}
			.text{
				padding-top: 20px;
				font-size: 18px;
				text-align: left;
			}
			.title{
				padding-top: 20px;
				font-size: 24px;
			}
			.logo{
				width: 154px;
			}
		}
	}
	//块1
	.block_1{
		width: 100%;
		margin: 0 auto;
		position: relative;
		padding: 40px 20px 70px 20px;
		.btn_main{
			text-align: center;
			.btn_el{
				height: 50px;
				line-height: 50px;
				margin-top: 40px;
				background-color: #F26F32;
				color: #ffffff;
				border: none;
				font-size: 20px;
				padding-top: 2px;
				border-radius: 46px;
			}
		}
		.block_1_el{
			width: 100%;
			padding-top: 40px;
			.msg_box{
				.text{
					padding-top: 12px;
					font-size: 18px;
				}
				.title{
					padding-top: 20px;
					font-size: 30px;
				}
			}
			.img_box{
				width: 100%;
				img{
					width: 100%;
				}
			}
		}
		.info_box{
			padding-top: 50px;
			text-align: center;
			.text{
				padding-top: 15px;
				font-size: 18px;
			}
			.title{
				font-size: 35px;
				line-height: 1;
			}
		}
		.block_1_top{
			width: 100%;
			.msg_box{
				.text{
					padding-top: 10px;
					font-size: 18px;
				}
				.tit{
					padding-top: 10px;
					font-size: 18px;
					color: #F26F32;
				}
				.title{
					padding-top: 40px;
					font-size: 30px;
				}
			}
			.img_box{
				img{
					width: 100%;
				}
			}
		}
	}
	//banner
	.banner_box{
		position: relative;
		.msg_box{
			width: 100%;
			position: absolute;
			top: 50%;
			transform: translate(0%, -50%);
			z-index: 1;
			padding: 20px;
			text-align: center;
			.btn_el{
				margin-top: 10px;
				color: #ffffff;
				background-color: #F26F32;
				border: 1px solid #F26F32;
			}
			.txt2{
				padding-top: 40px;
				color: #F26F32;
				font-size: 18px;
			}
			.txt{
				padding-top: 15px;
				font-size: 18px;
			}
			.tit{
				padding-top: 15px;
				color: #F26F32;
				font-size: 18px;
			}
			.title{
				font-size: 36px;
				font-weight: bold;
				line-height: 1.1;
			}
		}
		.bg{
			width: 100%;
		}
	}
	.btn_box{
		display: inline-block;
		padding: 0px 28px 0 28px;
		height: 40px;
		line-height: 40px;
		font-size: 18px;
		color: #0B318F;
		background: transparent;
		border-radius: 22px;
		border: 1px solid #0B318F;
		text-align: center;
		cursor: pointer;
		img{
			width: 20px !important;
			min-width: 20px !important;
			position: relative;
			top: 8px;
			left: 10px;
			transition: all 0.3s;
		}
	}
}
</style>
